
export default {
  head() {
    return {
      title: "Αναζήτηση",
      meta: [
        {
          name: "robots",
          content: "noindex",
        },
      ],
    };
  },
  name: "searchResults",
  mounted() {
    if (process.client) {
      const existingScript = document.querySelector(
        'script[src="https://app.findbar.io/js/pharmacy295.gr/findbar.js"]'
      );
      if (!existingScript) {
        const script = document.createElement("script");
        script.src = "https://app.findbar.io/js/pharmacy295.gr/findbar.js";
        script.async = true;
        document.body.appendChild(script);
      }
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   if (process.client) {
  //     const cookieValue = document.cookie
  //       .split("; ")
  //       .find((row) => row.startsWith("hello_findbar="))
  //       ?.split("=")[1];

  //     if (cookieValue === "dev") {
  //       next();
  //     } else {
  //       next("/"); // Redirect to another page if the cookie is not present
  //     }
  //   } else {
  //     next();
  //   }
  // },
};
